import Proxy from "./Proxy"

class ProductTypeProxy extends Proxy {
  constructor(parameters = {}) {
    super("product-types", parameters)
  }
}

export default ProductTypeProxy
